/**
 * TABLIST TOKENS
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createTablistTokens(s: SemanticTokens) {
  return {
    /** Base spacing for tablists */
    base: {
      paddingTab: v('tablist.base.padding-x'), // --tablist-base-padding-x: var(--spacing-16)
      paddingTabY: v('tablist.base.padding-y'), // --tablist-base-padding-y: var(--spacing-16)
      paddingPanel: '0',
      gap: s.layout.gap.sm, // --tablist-base-gap: var(--spacing-8)
      radius: v('tablist.base.radius'), // --tablist-base-radius: var(--radius-8)
    },
    bg: v('tablist.bg'), // --tablist-bg: var(--color-neutral-600)
    bgHover: s.surface.ground, // --tablist-bg-hover: var(--surface-ground)
    bgActive: s.surface.ground, // --tablist-bg-active: var(--surface-ground)
    bgDisabled: s.surface.disabled, // --tablist-bg-disabled: var(--surface-disabled)
    border: s.border.strong, // --tablist-border: var(--border-strong)
    fg: s.text.onColor, // --tablist-fg: var(--text-on-color)
    fgActive: s.text.secondary, // --tablist-fg-active: var(--text-secondary)
    fgDisabled: s.text.onColor, // --tablist-fg-disabled: var(--text-on-color)
    fontFamily: s.typography.fontFamily.base, // --tablist-font-family
    fontSize: s.typography.fontSize.base, // --tablist-font-size (16px)
    lineHeight: s.typography.lineHeight.xl, // --tablist-line-height (24px)
    fontWeight: s.typography.fontWeight.semibold, // --tablist-font-weight
    borderWidth: '1px', // --tablist-border-width
    transitionDuration: s.transition.normal, // --tablist-transition-duration
    navButton: {
      width: s.iconSizes.xl, // --tablist-nav-button-width
    },
  };
}
export const tablistTokens = createTablistTokens(SEMANTIC);
